import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as space from '../../space'

export const RESOURCE = {
  payload: {
    description:
      'A level within a building that contains rooms, acting as an intermediary between the overall structure and individual rooms.',
    dimension: space.RESOURCE.payload,
    level: 2,
    name: 'Floor',
    partialId: PartialId.Standard.create('floor'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
